//import { param } from 'jquery';

var pdfMake = require('pdfmake/build/pdfmake.js');
var pdfFonts = require('pdfmake/build/vfs_fonts.js');
pdfMake.addVirtualFileSystem(pdfFonts);
//pdfMake.vfs = pdfFonts.pdfmake.vfs;

const htmlToPDF = require('html-to-pdfmake')
import {identifyStringFormat} from '@/assets/js/JSONorHTML.js';


pdfMake.fonts = {
  Calibri: {
    normal: 'calibri.ttf',
    bold: 'calibrib.ttf',
    italics: 'calibrii.ttf',
    bolditalics: 'calibriz.ttf'
  }
}

const { logoString } =  require('/src/assets/js/logo.js');


function fileDownload(paramId, paramProjectTask, paramActivity, paramName, paramDate, paramDivision, action) {
    let activityList = []
    let dataType = identifyStringFormat(paramActivity);
    
    if(dataType == 'HTML'){
      activityList = htmlToPDF(paramActivity);
    } else if(dataType == 'JSON'){
      if (paramActivity != null)
      {
        paramActivity = JSON.parse(paramActivity);

        for(let x = 0; x < paramActivity.content[0].content.length; x = x + 1) {

          activityList = activityList + '•  ' + paramActivity.content[0].content[x].content[0].content[0].text + '\n';

          if(paramActivity.content[0].content[x].content.length > 1) {
            for(let y = 0; y < paramActivity.content[0].content[x].content[1].content.length; y = y + 1) {

              activityList = activityList + '\u200B\t○  ' + paramActivity.content[0].content[x].content[1].content[y].content[0].content[0].text + '\n';

              if(paramActivity.content[0].content[x].content[1].content[y].content.length > 1) {
                for(let z = 0; z < paramActivity.content[0].content[x].content[1].content[y].content[1].content.length; z = z + 1) {
                  
                  activityList = activityList + '\u200B\t\u200B\t□ ' + paramActivity.content[0].content[x].content[1].content[y].content[1].content[z].content[0].content[0].text + '\n';

                }
              }
            }
          }
        }
      }
      else
      {
        activityList = 'NA'
      }
    } else {
      activityList = 'NA'
    }
    
    var weeklyPDF = {
        content: [
        { image: 'logo', width: 500, height: 75 },
        { text: '690 Discovery Dr NW | Huntsville, AL 35806', style: 'smolHeader' },
        { text: '256.327.3410 Office | QuadrusCorp.com', style: 'smolHeader' },
        { text: 'Weekly Activity Report (WAR)', style: 'header', margin: [0,10]},
        
        {
          table: {
            // headers are automatically repeated if the table spans over multiple pages
            // you can declare how many rows should be treated as headers
            headerRows: 0,
            widths: [ '*', '*'],
    
            body: [
              [ { text: 'Employee Name', bold: true }, paramName],
              [ { text: 'Charge Line / PC Number\n(if applicable)', bold: true }, paramProjectTask ],
              [ { text: 'Division', bold: true }, paramDivision ],
              [ { text: 'Date Range', bold: true }, paramDate ],
            ]
          }
        },
        
        { text: 'Please list the tasks and status below:', bold: true, margin: [0, 12], decoration: 'underline' },
        activityList
      ],
            
      
      images: {
        logo: logoString
      },
      styles: {
            header: {
                fontSize: 16,
                bold: true,
                alignment: 'center'
            },
            smolHeader: {
                fontSize: 10,
                alignment: 'center'
            }
      },
      defaultStyle: {
        font: 'Calibri'
      },
      info: {
        title: 'WAR'
      }
    }

    if (action === 'Download') {
      let fileName = paramName + '_' + paramDate + '_WAR.pdf';
      pdfMake.createPdf(weeklyPDF).download(fileName);
    } else if (action === 'Preview') {
      pdfMake.createPdf(weeklyPDF).open();
    }

    return 0;
}


async function QIPPreview(qipInfo) {
  var QIP_PDF = {
    content: [
      { image: 'logo', width: 500, height: 75 },
      { text: '690 Discovery Dr NW | Huntsville, AL 35806', style: 'smolHeader' },
      { text: '256.327.3410 Office | QuadrusCorp.com', style: 'smolHeader' },
      { text: 'QIP for QCR #' + qipInfo.QCRnumber, style: 'header', margin: [0,10]},
      
      {
          table: {
          // headers are automatically repeated if the table spans over multiple pages
          // you can declare how many rows should be treated as headers
          headerRows: 0,
          widths: [ '*', '*'],
  
          body: [
              [ { text: 'QIP-1 Author', bold: true }, qipInfo.author1],
              [ { text: 'QIP-2 Author', bold: true }, qipInfo.author2]
          ]
          }
      },
      
      { text: '1. Introduction', bold: true, margin: [0, 12]},
      { text: qipInfo.introduction },
      { text: '1.1 QCR Description', bold: true, margin: [0, 12]},
      { text: qipInfo.description },
      { text: '2. Design Analysis ', bold: true, margin: [0, 12]},
      { text: '2.1 Recommeded Design Approach', bold: true, margin: [0, 12]},
      { text: qipInfo.designApproach },
      { text: '2.2 Alternate Design Approach', bold: true, margin: [0, 12]},
      { text: qipInfo.designApproach2 },
      { text: '3. Affected Documents', bold: true, margin: [0, 12]},
      { text: '3.1 User Manual', bold: true, margin: [0, 12]},
      { text: qipInfo.userManual },
      { text: '3.2 Requirements Documentation', bold: true, margin: [0, 12]},
      { text: qipInfo.requirements },
      { text: '3.3 Design Documentation', bold: true, margin: [0, 12]},
      { text: qipInfo.designDoc },
      { text: '3.4 Software Development Plan', bold: true, margin: [0, 12]},
      { text: qipInfo.developmentPlan },
      { text: '3.5 Software Test Plan', bold: true, margin: [0, 12]},
      { text: qipInfo.testPlan },
      { text: '3.6 Formal Qualification Test Procedure', bold: true, margin: [0, 12]},
      { text: qipInfo.fqtProcedure },
      { text: '3.7 Software Test Report', bold: true, margin: [0, 12]},
      { text: qipInfo.testReport },
      { text: '3.8 Process Documentation', bold: true, margin: [0, 12]},
      { text: qipInfo.processDoc },
      { text: '3.9 Other Documentation', bold: true, margin: [0, 12]},
      { text: qipInfo.otherDoc },
      { text: '4. Required Non-Labor Resources', bold: true, margin: [0, 12]},
      { text: qipInfo.resources },
      { text: '5. Required Travel', bold: true, margin: [0, 12]},
      { text: qipInfo.travel },
      { text: '6. Design Details', bold: true, margin: [0, 12]},
      { text: '6.1 Functionality Changes', bold: true, margin: [0, 12]},
      { text: '6.1.1 Changes to Product', bold: true, margin: [0, 12]},
      { text: '6.1.1.1 Class', bold: true, margin: [0, 12]},
      { text: qipInfo.className },
      { text: '6.2 Integration', bold: true, margin: [0, 12]},
      { text: qipInfo.integration },
      { text: '6.3 Interfaces', bold: true, margin: [0, 12]},
      { text: '6.3.1 External Interfaces', bold: true, margin: [0, 12]},
      { text: qipInfo.externalInterfaces },
      { text: '6.3.2 Internal Interfaces', bold: true, margin: [0, 12]},
      { text: qipInfo.internalInterfaces },
      { text: '6.4 Reuse', bold: true, margin: [0, 12]},
      { text: qipInfo.reuse},
    ],
    images: {
      logo: logoString
    },
    styles: {
        header: {
            fontSize: 16,
            bold: true,
            alignment: 'center'
        },
        smolHeader: {
            fontSize: 10,
            alignment: 'center'
        }
    },
    defaultStyle: {
      font: 'Calibri'
    },
    info: {
      title: 'QIP for QCR #' + qipInfo.QCRnumber
    }
  }  
  
  pdfMake.createPdf(QIP_PDF).open();

  return 0;
}


function STRDownload(STRData, qcrId, action) {
  var STR_PDF = {
      content: [
      { image: 'logo', width: 500, height: 75 },
      { text: '690 Discovery Dr NW | Huntsville, AL 35806', style: 'smolHeader' },
      { text: '256.327.3410 Office | QuadrusCorp.com', style: 'smolHeader' },
      { text: 'Formal Qualification Test Report for Build #'+ qcrId, style: 'header', margin: [0,10]},
      
      {
        table: {
          // headers are automatically repeated if the table spans over multiple pages
          // you can declare how many rows should be treated as headers
          headerRows: 0,
          widths: [ '*', '*'],
  
          body: [
            [ { text: 'Author', bold: true }, STRData.author],
          ]
        }
      },
      
      { text: '1. Scope', bold: true, margin: [0, 12]},
      { text: '1.1 Identification', bold: true, margin: [0, 12]},
      { text: STRData.identification },
      { text: '1.2 System Overview', bold: true, margin: [0, 12]},
      { text: STRData.sysOverview },
      { text: '2. Document Overview', bold: true, margin: [0, 12]},
      { text: '2.1 Government Documents', bold: true, margin: [0, 12]},
      { text: STRData.govDocs },
      { text: '2.2 Non-Government Documents', bold: true, margin: [0, 12]},
      { text: STRData.nonGovDocs },
      { text: '2.3 Order of Precedence', bold: true, margin: [0, 12]},
      { text: 'In the event of a conflict between the text of this document and the references cited herein, the text of this document takes precedence, unless otherwise specified. Nothing in this document, however, supersedes applicable laws and regulations unless a specific exemption has been obtained.', bold: false, margin: [0, 12]},
      { text: STRData.precedence },
      { text: '3. Overview of Results', bold: true, margin: [0, 12]},
      { text: '3.1 Overall Assessment of the Software Tested', bold: true, margin: [0, 12]},
      { text: STRData.assessment },
      { text: '3.2 Impact of the Test Environment', bold: true, margin: [0, 12]},
      { text: STRData.environmentImpacts },
      { text: '3.3 Recommended Improvements', bold: true, margin: [0, 12]},
      { text: STRData.improvements },
      { text: '4. Detsiled Test Results', bold: true, margin: [0, 12]},
      { text: '4.1 1st Project Unique identifier', bold: true, margin: [0, 12]},
      { text: '4.1.1 Summary of the Test Results', bold: true, margin: [0, 12]},
      { text: STRData.testResults1 },
      { text: '4.1.2 Problems Encountered', bold: true, margin: [0, 12]},
      { text: STRData.problems1 },
      { text: '4.2 2nd Project Unique identifier', bold: true, margin: [0, 12]},
      { text: '4.2.1 Summary of the Test Results', bold: true, margin: [0, 12]},
      { text: STRData.testResults2 },
      { text: '4.2.2 Problems Encountered', bold: true, margin: [0, 12]},
      { text: STRData.problems2 },
      { text: '4.2.3 Deviations from Test Cases/Procedures', bold: true, margin: [0, 12]},
      { text: '4.2.3.1 1st Project-unique identifier of a test case', bold: true, margin: [0, 12]},
      { text: STRData.deviation1 },
      { text: '4.2.3.2 2nd Project-unique identifier of a test case', bold: true, margin: [0, 12]},
      { text: STRData.deviation2 },
      { text: '5. Test Log', bold: true, margin: [0, 12]},
      { text: STRData.testLog },
      { text: '6. Notes', bold: true, margin: [0, 12]},
      { text: STRData.Notes },
    ],
    images: {
      logo: logoString
    },
    styles: {
          header: {
              fontSize: 16,
              bold: true,
              alignment: 'center'
          },
          smolHeader: {
              fontSize: 10,
              alignment: 'center'
          }
    },
    defaultStyle: {
      font: 'Calibri'
    },
    info: {
      title: 'STR'
    }
  }

  if (action === 'Download') {
    let fileName =  'Build' + qcrId + '_STR.pdf';
    pdfMake.createPdf(STR_PDF).download(fileName);
  } else if (action === 'Preview') {
    pdfMake.createPdf(STR_PDF).open();
  }

  return 0;
}

export { fileDownload, QIPPreview, STRDownload }